/*
 * Copyright (c) 2022 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import Xbts from '@/services/xbts';

export default {
    namespaced: true,

    state: {
        featuredPrice: {
            bts: {
                usd: 0,
                cny: 0,
                rub: 0,
            },
        },
        currency: "usd",
        tickers: {},
    },

    getters: {
        featuredPrice: state => state.featuredPrice,
        currency: state => state.currency,
        tickers: state => state.tickers,
    },

    mutations: {
        SET_FEATURED_PRICE(state, payload) {
            state.featuredPrice = payload;
        },
        SET_CURRENCY(state, payload) {
            state.currency = payload;
        },
        SET_TICKERS(state, payload) {
            state.tickers = payload;
        },
    },

    actions: {
        async setCurrency({commit}, value) {
            commit('SET_CURRENCY', value);
        },
        async fetchFeaturedPrice({commit}) {
            const data = await Xbts.fetchFeaturedPrice();
            if (data) {
                commit('SET_FEATURED_PRICE', data);
            }
            return data;
        },
        async tickers({commit}) {
            const data = await Xbts.tickers();
            if (data) {
                commit('SET_TICKERS', data);
            }
        },
    }
}
